import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBrokenHeartIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.31219 4.12138C6.83281 4.75487 6.47831 5.48846 6.20272 6.17326L6.07934 6.47982L8.0945 8.49498L7.36744 10.6762L8.31612 10.9924L9.23863 8.22489L7.257 6.24327C7.55 5.56703 7.90716 4.92035 8.36297 4.41849C9.30376 3.46581 10.3717 3.22317 11.2836 3.42698C12.2101 3.63407 13.0231 4.3121 13.4164 5.29516C14.1688 7.17586 13.4242 10.486 7.99993 13.6179C2.65394 10.5311 1.8532 7.26916 2.55111 5.37912C2.91518 4.39315 3.69597 3.69886 4.59917 3.45581C5.43805 3.23006 6.41674 3.38455 7.31219 4.12138ZM7.99992 3.39288C6.85325 2.4233 5.52185 2.17194 4.33931 2.49016C3.11327 2.82009 2.08587 3.75217 1.61302 5.03272C0.647606 7.64722 2.02314 11.4087 7.75501 14.6292L7.99993 14.7668L8.24485 14.6292C14.058 11.363 15.3907 7.53796 14.3449 4.92372C13.8334 3.64534 12.7616 2.73267 11.5017 2.45106C10.3561 2.195 9.09316 2.46861 7.99992 3.39288Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBrokenHeartIcon);
export default ForwardRef;
